import { render, staticRenderFns } from "./appletBasic.vue?vue&type=template&id=166ab725&"
import script from "./appletBasic.vue?vue&type=script&lang=js&"
export * from "./appletBasic.vue?vue&type=script&lang=js&"
import style0 from "./appletBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports